export default "__VITE_ASSET__jGd_xSW8__"